import React from 'react'
import { InfoModal } from 'asterX-UI/Modals'
import { SessionStorageService } from 'lib/utils'
import { HOME_PATH } from 'routes/constants.routes'
import { useNavigate, useLocation } from 'react-router-dom'
import { GRAY_COLORS } from './colors.constant'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: { message: '', stack: '' },
      info: { componentStack: '' }
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, info: errorInfo })
  }

  onClose = () => {
    const { navigate } = this.props
    const prevPage = SessionStorageService.getPrevPage()
    const pathname = window.location.pathname

    navigate(prevPage === pathname ? HOME_PATH : prevPage)
    this.setState({ error: null, info: null, hasError: false })
  }

  render() {
    const { hasError, error, info } = this.state
    if (hasError) {
      return (
        <InfoModal
          open={hasError}
          variant={'info'}
          title={'Произошла ошибка !'}
          onClose={this.onClose}
          btnText={'Закрыть'}
        >
          <div
            style={{
              whiteSpace: 'pre-wrap',
              background: GRAY_COLORS[300],
              borderRadius: 5,
              overflowY: 'auto',
              maxHeight: 320,
              overflowWrap: 'break-word',
              padding: 10
            }}
          >
            {error && error.toString()}
            <br />
            {info.componentStack}
          </div>
        </InfoModal>
      )
    }

    return this.props.children
  }
}

function ErrorBoundaryWithRouter(props) {
  const navigate = useNavigate()
  const location = useLocation()

  return <ErrorBoundary navigate={navigate} location={location} {...props} />
}

export default ErrorBoundaryWithRouter
